import { createContext, useContext } from 'react'

import { type QuoteContext } from './QuoteComponent.types'

const QuoteComponentContext = createContext<QuoteContext | null>(null)

type QuoteComponentContextProviderProps = QuoteContext & {
  children?: React.ReactNode
}

export const QuoteComponentContextProvider: React.FC<QuoteComponentContextProviderProps> = ({
  children,
  ...context
}) => {
  return (
    <QuoteComponentContext.Provider value={context}>
      { children }
    </QuoteComponentContext.Provider>
  )
}

export const useQuoteContext = () => {
  const context = useContext(QuoteComponentContext)
  if (!context) {
    throw new Error('Missing QuoteComponent context. Did you forget to use <QuoteComponent/> ?')
  }
  return context
}
